import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from '@/utils/request';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Object.defineProperty(Vue.prototype, '$http', {
  get: () => request,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
